import { render, staticRenderFns } from "./BasisVideoPlayer.vue?vue&type=template&id=ddde9aca&scoped=true&"
import script from "./BasisVideoPlayer.vue?vue&type=script&lang=js&"
export * from "./BasisVideoPlayer.vue?vue&type=script&lang=js&"
import style0 from "./BasisVideoPlayer.vue?vue&type=style&index=0&id=ddde9aca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddde9aca",
  null
  
)

export default component.exports